import styled from '@emotion/styled';

export const OuterWrap = styled.div`
  position: relative;
`;
export const HomeScreen = styled.div`
  margin: 24px 16px;
  @media (min-width: 768px) {
    margin: 48px 40px;
  }
  @media (min-width: 1024px) {
    margin: 48px auto 0;
    width: 900px;
  }
  @media (min-width: 1630px) {
    width: 952px;
  }
`;

export const TopBarStyles = styled.div`
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c0bcb4;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  height: 70px;
  .site_logo {
    width: 94px;
    height: auto;
  }
  @media (min-width: 768px) {
    padding: 0 40px;
  }
  @media (min-width: 1024px) {
    padding: 0 70px;
  }
  @media (min-width: 1700px) {
    padding: 0 230px;
  }
`;
export const Logout = styled.div`
  height: 80px;
  width: 160px;
  background-color: white;
  /* display: flex; */
  align-items: center;
  position: absolute;
  flex-direction: column;
  right: 0;
  top: 60px;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  z-index: 500;
  @media (min-width: 768px) {
    flex-direction: initial;
  }
  @media (min-width: 1024px) {
    width: 216px;
    height: 80px;
  }
`;
export const LogoutStyles = styled.span`
  height: 40px;
  width: 100%;
  padding-left: 24px;
  display: flex;
  align-items: center;
  :hover {
    background-color: #eae8e5;
  }
`;
export const NewOrderStyles = styled.div`
  height: 40px;
  width: 100%;
  padding-left: 24px;
  display: flex;
  align-items: center;
  :hover {
    background-color: #eae8e5;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;
export const DropdownStyles = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14),
    0px 1px 3px rgba(0, 0, 0, 0.12);
  width: 148px;
  padding: 20px;
  position: absolute;
  right: 16px;
  top: 60px;
  z-index: 50;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const MenuIconStyles = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;
export const IconStyles = styled.div`
  display: flex;
  align-items: center;
  .add_new_order_button {
    text-transform: uppercase;
    font-size: 12px;
    /* text-decoration: underline; */
    font-weight: bold;
    cursor: pointer;
    transition: all 0.1s;
    margin-right: 16px;
    color: #444;
    :last-of-type {
      margin-right: 0;
    }
    :hover {
      /* color: #93918f; */
      text-decoration: underline;
      color: #333;
    }
  }
  @media (max-width: 767px) {
    display: none;
  }
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }
`;
export const TopInfo = styled.div`
  @media (max-width: 1023px) {
    display: none;
  }
  @media (min-width: 1024px) {
    position: relative;
    display: flex;
    margin-left: 48px;
  }
`;
export const SearchInputMobile = styled.div`
  display: flex;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const SearchInputDesktop = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
  }
`;
export const CardLayout = styled.div`
  display: block;
  margin-bottom: 32px;
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    margin-bottom: 48px;
    /* max-width:250px; */
  }
  @media (min-width: 1024px) {
    max-width: 900px;
  }
  @media (min-width: 1630px) {
    max-width: 952px;
  }
`;
export const ButtonStyles = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 56px;
  @media (min-width: 1260px) {
    margin-top: 20px;
  }
`;

export function HudsonH({ ...props }: any) {
  return (
    <svg width="40" height="78" viewBox="0 0 40 78" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_480_503)">
        <path
          d="M17.1417 0L2.86717 5.89832C1.15719 6.60109 0.0419922 8.27437 0.0419922 10.1317V78L14.8948 63.066C16.3322 61.6186 17.1417 59.6525 17.1417 57.6111V0Z"
          fill="#EC3E43"
        />
        <path
          d="M22.0322 23.0243V54.6493C22.0322 57.77 23.3952 60.7317 25.7661 62.7396L39.7433 74.6116V33.8002C39.7433 31.558 38.3802 29.5501 36.3151 28.7218L22.0322 23.0243Z"
          fill="#EC3E43"
        />
        <path
          d="M21.8178 71.4072V77.9916H39.9502L26.1465 69.0061C24.2713 67.7846 21.8096 69.1483 21.8096 71.4072H21.8178Z"
          fill="#EC3E43"
        />
      </g>
      <defs>
        <clipPath id="clip0_480_503">
          <rect width="40" height="78" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
